module.exports = __webpack_public_path__ + "static/img/荣耀 MagicBook Art 14.20c6710b.png";